import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex p-3 border-bottom mb-4 align-items-end fluid-content"
}
const _hoisted_2 = { class: "text-uppercase m-0" }
const _hoisted_3 = {
  key: 1,
  class: "d-flex align-items-center justify-content-center flex-column vh-100 text-center"
}
const _hoisted_4 = { class: "card w-50" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  key: 2,
  class: "row row-cols-1 row-cols-sm-2 row-cols-xl-4 g-4 mb-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multiple_card_placeholders = _resolveComponent("multiple-card-placeholders")!
  const _component_event_card = _resolveComponent("event-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_multiple_card_placeholders, {
          key: 0,
          admin: true,
          total: 3,
          hasTitle: true
        }))
      : _createCommentVNode("", true),
    (!_ctx.loading && _ctx.loaded)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.events.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("h3", _hoisted_2, [
                  _cache[2] || (_cache[2] = _createTextVNode(" Eventos eliminados ", -1)),
                  _createElementVNode("strong", null, "(" + _toDisplayString(_ctx.events.length) + ")", 1)
                ]),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goListEvents && _ctx.goListEvents(...args))),
                  class: "btn btn-primary ms-auto"
                }, [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1),
                  _createTextVNode(" Regresar ", -1)
                ]))])
              ]))
            : _createCommentVNode("", true),
          (_ctx.events.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _cache[5] || (_cache[5] = _createElementVNode("h1", null, [
                      _createElementVNode("i", {
                        class: "fas fa-ticket-alt",
                        style: {"font-size":"2em"}
                      })
                    ], -1)),
                    _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "mb-0" }, "Aún no hay eventos eliminados.", -1)),
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goListEvents && _ctx.goListEvents(...args))),
                      class: "btn btn-primary mt-2"
                    }, [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1),
                      _createTextVNode(" Regresar ", -1)
                    ]))])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.events.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event, ind) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "col",
                    key: ind
                  }, [
                    _createVNode(_component_event_card, {
                      event: event,
                      admin: true,
                      onGetEvents: _ctx.getEvents
                    }, null, 8, ["event", "onGetEvents"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}